module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page-bg",
    class: _vm.classes + (_vm.status ? ' all' : ''),
    domProps: {
      "innerHTML": _vm._s(_vm.html)
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.toCancel($event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-40436416!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/component/pages.vue
// module id = 156
// module chunks = 2